import React from "react";

import TimelineCounter from "./TimelineCounter";
import CollageImages from "./CollageImages";

const CollageGrid = () => {
  return (
    <div className="overflow-hidden w-full h-full">
      <CollageImages />
      <TimelineCounter />
    </div>
  );
};

export default CollageGrid;
